import React from 'react';

export default function RightAlignIcon() {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' width='24' height='21' fill='none' viewBox='0 0 24 21'>
            <path fill='#1F1F1F' fillOpacity='0.7' d='M0 0v3h24V0H0zm0 6v3h24V6H0zm0 6v3h24v-3H0zm6 6v3h18v-3H6z' />
        </svg>
    );
}
